<template>
  <v-container fluid class="h-100 pa-0">
    <section v-if="detailLoading" class="loader-container">
      <Loader text="Cargando pedido" />
    </section>

    <v-card
      class="request-detail-card"
      v-else
      flat
      :class="{ urgent: request?.is_urgency }"
    >
      <div
        v-if="!!fab"
        @click="fab = false"
        class="menu-overlay"
        :class="{ overlay: fab }"
      ></div>

      <div>
        <v-row no-gutters v-if="request">
          <div class="left-col" ref="leftCol" v-bind:class="{ hidden: fab }">
            <v-row>
              <!-- Urgency -->
              <v-col cols="12" style="color: #ff5252" v-if="request.is_urgency">
                <b>PEDIDO URGENTE</b>
              </v-col>

              <!-- Request Status -->
              <v-col cols="12">
                <v-chip
                  label
                  color="rapiblue"
                  text-color="white"
                  :class="{ dim: fab }"
                >
                  {{ request?.status_request?.description }}
                </v-chip>
              </v-col>

              <!-- Scheme Icon and Service name -->
              <v-col class="d-flex flex-column" style="gap: 1rem" cols="12">
                <h6 class="text-subtitle-1 text-md-h6 font-weight-bold">
                  Tipo de servicio
                </h6>
                <p
                  style="
                    text-transform: capitalize;
                    display: flex;
                    align-items: center;
                  "
                >
                  <template v-if="$store.state.app_display_scheme">
                    <div v-if="request.scheme" class="mr-2">
                      <SchemeIcon
                        :scheme="request.scheme"
                        style="min-width: 25px; min-height: 24px"
                      />
                    </div>
                  </template>
                  <span class="text-subtitle-2 text-md-subtitle-1">
                    {{ request.service?.name }}
                  </span>
                </p>
              </v-col>

              <!-- Visitas -->
              <template v-if="currentVisit">
                <!-- Visit without confirmation || Visit in pending -->
                <v-col
                  v-if="currentVisit.visit_status === 1"
                  cols="12"
                  class="d-flex flex-column"
                  style="gap: 1rem"
                >
                  <p class="hidden-md-and-up">
                    <b v-if="currentVisit.visit_type.id === 4"
                      >Visita NO confirmada</b
                    >
                    <b v-else>Visita pendiente</b>
                  </p>
                  <v-chip
                    label
                    color="rapired"
                    text-color="white"
                    :class="{ dim: fab }"
                  >
                    <span
                      v-if="currentVisit.visit_type.id === 4"
                      class="hidden-sm-and-down"
                      >Visita NO confirmada:
                    </span>
                    <span v-else class="hidden-sm-and-down"
                      >Visita pendiente:
                    </span>
                    <span
                      v-if="currentVisit"
                      style="
                        font-weight: bold;
                        margin-left: 6px;
                        text-transform: capitalize;
                      "
                    >
                      {{
                        currentVisit.visit_date &&
                        formatDate(currentVisit.visit_date)
                      }}, {{ currentVisit.arrival_time }} -
                      {{ currentVisit.departure_time }} hs
                    </span>
                  </v-chip>
                </v-col>

                <!-- Visit in progress -->
                <v-col v-else-if="currentVisit.visit_status === 8" cols="12">
                  <v-chip
                    label
                    color="secondary"
                    text-color="white"
                    :class="{ dim: fab }"
                  >
                    <span>Visita en curso</span>
                  </v-chip>
                </v-col>

                <!-- Without visits -->
                <v-col v-else-if="request?.status_request?.id != 13" cols="12">
                  <v-chip
                    label
                    color="secondary"
                    text-color="white"
                    :class="{ dim: fab }"
                  >
                    <span>El pedido no tiene visitas pendientes</span>
                  </v-chip>
                </v-col>
              </template>

              <!-- Client information -->
              <template v-if="request.client">
                <v-col class="d-flex flex-column" style="gap: 1rem" cols="12">
                  <h6 class="text-subtitle-1 text-md-h6 font-weight-bold">
                    Cliente
                  </h6>

                  <div class="d-flex flex-column" style="gap: 1rem">
                    <p class="text-subtitle-2 text-md-subtitle-1">
                      {{
                        request.client.last_name
                          ? request.client.last_name
                          : ""
                      }},
                      {{
                        request.client.first_name
                          ? request.client.first_name
                          : ""
                      }}
                    </p>

                    <div v-if="request.client.full_cell_phone">
                      <v-row
                        no-gutters
                        class="d-flex align-center justify-space-between"
                      >
                        <p class="text-subtitle-2 text-md-subtitle-1">
                          {{ request.client.full_cell_phone }}
                        </p>
                        <a
                          class="hidden-md-and-up"
                          :href="'tel:' + request.client.full_cell_phone"
                          ><v-icon color="rapired" :class="{ dim: fab }"
                            >smartphone</v-icon
                          ></a
                        >
                      </v-row>
                    </div>
                  </div>
                </v-col>
              </template>

              <!-- Request address  -->
              <v-col cols="12" class="d-flex flex-column" style="gap: 1rem">
                <h6 class="text-subtitle-1 text-md-h6 font-weight-bold">
                  Dirección:
                </h6>
                <div
                  class="d-flex align-center"
                  style="gap: 1rem"
                  :class="{
                    'justify-space-between': $vuetify.breakpoint.smAndDown,
                  }"
                >
                  <p
                    class="text-subtitle-2 text-md-subtitle-1"
                    style="text-transform: capitalize"
                  >
                    {{ request.full_address }}
                  </p>
                  <a
                    v-if="googleMapsLink"
                    :href="googleMapsLink"
                    target="_blank"
                  >
                    <v-icon color="rapired" :class="{ dim: fab }">room</v-icon>
                  </a>
                </div>
              </v-col>

              <!-- Request description -->
              <v-col cols="12" class="d-flex flex-column" style="gap: 1rem">
                <h6 class="text-subtitle-1 text-md-h6 font-weight-bold">
                  Descripción del servicio
                </h6>
                <p class="my-0 text-subtitle-2 text-md-subtitle-1">
                  {{ request.description }}
                </p>
              </v-col>

              <!-- Show visits -->
              <template v-if="showVisits">
                <v-col cols="12">
                  <v-row
                    no-gutters
                    class="d-flex flex-column"
                    style="gap: 1rem"
                  >
                    <v-col cols="12" class="pa-0">
                      <h6 class="text-subtitle-1 text-md-h6 font-weight-bold">
                        Visitas
                      </h6>
                    </v-col>

                    <div
                      class="d-flex flex-column"
                      style="gap: 1rem; width: 100%"
                    >
                      <v-col
                        cols="12"
                        md="6"
                        class="pa-0"
                        v-for="visit in visits"
                        :key="visit.id"
                      >
                        <div
                          class="d-flex align-center pa-3"
                          style="border-radius: 5px"
                          :class="{
                            highlighted:
                              visit.visit_status === 1 ||
                              visit.visit_status === 8 ||
                              visit.visit_status === 12,
                            regular: visit.visit_status !== 1,
                          }"
                        >
                          <v-icon
                            color="warning"
                            v-if="visit.visit_status === 1"
                            :class="{ dim: fab }"
                            >event</v-icon
                          >
                          <v-icon
                            color="success"
                            v-if="
                              visit.visit_status === 2 ||
                              visit.visit_status === 14
                            "
                            :class="{ dim: fab }"
                            >check</v-icon
                          >
                          <v-icon
                            color="warning"
                            v-if="
                              visit.visit_status === 3 ||
                              visit.visit_status === 4
                            "
                            :class="{ dim: fab }"
                            >error</v-icon
                          >
                          <v-icon
                            color="success"
                            v-if="visit.visit_status === 8"
                            :class="{ dim: fab }"
                            >home</v-icon
                          >
                          <v-icon
                            color="success"
                            v-if="visit.visit_status === 12"
                            :class="{ dim: fab }"
                            >store</v-icon
                          >
                          <v-icon
                            color="error"
                            v-if="
                              visit.visit_status === 5 ||
                              visit.visit_status === 6 ||
                              visit.visit_status === 7 ||
                              visit.visit_status === 9 ||
                              visit.visit_status === 10 ||
                              visit.visit_status === 11 ||
                              visit.visit_status === 13
                            "
                            :class="{ dim: fab }"
                          >
                            clear
                          </v-icon>
                          <div class="ml-2">
                            <p
                              style="
                                margin-bottom: 0px;
                                font-size: 13px;
                                font-weight: bold;
                              "
                            >
                              <span
                                v-if="visit.visit_type.id === 4"
                                style="
                                  font-size: 14px;
                                  font-weight: bold;
                                  border-radius: 12px;
                                  background-color: #c8272a;
                                  padding: 2px 6px;
                                  color: white;
                                "
                              >
                                No Confirmada
                              </span>
                              <span v-else-if="visit.visit_status === 8">
                                Servicio en curso
                              </span>
                              <span v-else>
                                {{ visit.visit_status_name }}
                              </span>
                            </p>
                            <p
                              style="
                                margin-bottom: 0;
                                text-transform: capitalize;
                              "
                            >
                              {{
                                visit.visit_date && formatDate(visit.visit_date)
                              }}
                            </p>
                            <p style="margin-bottom: 0">
                              de {{ visit.arrival_time }} a
                              {{ visit.departure_time }} hs
                            </p>
                          </div>
                        </div>
                      </v-col>
                    </div>
                  </v-row>
                </v-col>
              </template>

              <template v-else-if="request?.status_request?.id != 13">
                <v-col cols="12" class="d-flex flex-column" style="gap: 1rem">
                  <h6 class="text-subtitle-1 text-md-h6 font-weight-bold">
                    Visitas
                  </h6>
                  <p>El pedido aún no tiene servicios</p>
                </v-col>
              </template>
              <!-- Budget information -->

              <BudgetsPreview v-if="request?.id" :requestId="request.id" />

              <v-col
                v-if="request?.status_request?.id == 13"
                cols="12"
                class="d-flex flex-column"
                style="gap: 1rem"
              >
                <h6
                  v-if="currentVisit?.visit_type?.id !== 4"
                  class="text-subtitle-1 text-md-h6 font-weight-bold"
                >
                  Visitas
                </h6>

                <v-radio-group
                  class="availability-options ma-0 pa-0"
                  hide-details
                  :disabled="hasResponded"
                  v-model="selectedAvailability"
                >
                  <div class="d-flex flex-column" style="gap: 1rem">
                    <div
                      v-for="(item, i) in request.availability"
                      :key="item.id || i"
                      class="d-flex align-center justify-space-between pa-3 availability-card"
                      :class="{
                        highlighted: selectedAvailability === item.id,
                        regular: selectedAvailability !== item.id,
                        'availability-card--disabled': hasResponded,
                      }"
                      @click="selectAvailability(item.id)"
                    >
                      <p
                        class="text-subtitle-2 text-md-subtitle-1 my-0 availability-card__label"
                      >
                        {{ getFormattedDate(item) }}
                      </p>
                      <v-radio
                        color="rapired"
                        :value="item.id"
                        readonly
                        tabindex="-1"
                        class="ma-0 availability-card__radio"
                      />
                    </div>
                  </div>
                </v-radio-group>
              </v-col>

              <!-- Diagnostic questions Cristopher-->
              <v-col
                v-if="request.diagnostic_questions"
                cols="12"
                class="d-flex flex-column"
                style="gap: 1rem"
              >
                <h6 class="text-subtitle-1 text-md-h6 font-weight-bold">
                  Preguntas de diagnóstico
                </h6>
                <div class="d-flex flex-column" style="gap: 1rem">
                  <p
                    class="text-subtitle-2 text-md-subtitle-1"
                    v-for="(item, i) in request.diagnostic_questions"
                    :key="i"
                  >
                    <v-icon
                      color="success"
                      v-if="item.checked"
                      :class="{ dim: fab }"
                      >assignment_turned_in</v-icon
                    >
                    <v-icon color="error" v-else :class="{ dim: fab }"
                      >remove_done</v-icon
                    >
                    {{ item.question }}
                  </p>
                </div>
              </v-col>
              <!-- Payment methods -->
              <v-col
                v-if="request?.payment_data"
                cols="12"
                class="d-flex flex-column"
                style="gap: 1rem"
              >
                <h6 class="text-subtitle-1 text-md-h6 font-weight-bold">
                  Métodos de pago
                </h6>
                <div class="d-flex flex-column" style="gap: 1rem">
                  <p
                    class="text-subtitle-2 text-md-subtitle-1"
                    v-for="(item, i) in request.payment_methods"
                    :key="i"
                  >
                    {{ item.name }}
                  </p>
                  <v-card
                    style="background-color: transparent"
                    :style="{
                      width: $vuetify.breakpoint.smAndDown ? '100%' : '50%',
                    }"
                    class="d-flex flex-column pa-4"
                    outlined
                    elevation="2"
                  >
                    <span
                      class="text-subtitle-2 text-md-subtitle-1 font-weight-bold"
                      >Nombre y Apellido:
                      <span class="font-weight-regular"
                        >{{ request.payment_data.nombre_prestador }}
                        {{ request.payment_data.apellido_prestador }}</span
                      ></span
                    >
                    <span
                      class="text-subtitle-2 text-md-subtitle-1 font-weight-bold"
                      >CUIT:
                      <span class="font-weight-regular">{{
                        request.payment_data.cuit
                      }}</span></span
                    >
                    <span
                      class="text-subtitle-2 text-md-subtitle-1 font-weight-bold"
                      >Banco:
                      <span class="font-weight-regular">{{
                        request.payment_data.banco
                      }}</span></span
                    >
                    <span
                      class="text-subtitle-2 text-md-subtitle-1 font-weight-bold"
                      >CBU:
                      <span class="font-weight-regular">{{
                        request.payment_data.cbu
                      }}</span></span
                    >
                  </v-card>
                </div>
              </v-col>
              <!-- Servicios facturados -->
              <v-col
                v-if="request.transactions?.length > 0"
                cols="12"
                class="d-flex flex-column"
                style="gap: 1rem"
              >
                <h6 class="text-subtitle-1 text-md-h6 font-weight-bold">
                  Servicios facturados
                </h6>
                <div class="d-flex flex-column" style="gap: 1rem">
                  <BillServiceCard
                    v-for="transaction of request.transactions"
                    :key="transaction.id"
                    :transaction="transaction"
                  />
                </div>
              </v-col>

              <!-- Comprobantes de pago -->
              <v-col
                v-if="request.proof_of_payment_list?.length > 0"
                cols="12"
                class="d-flex flex-column"
                style="gap: 1rem"
              >
                <h6 class="text-subtitle-1 text-md-h6 font-weight-bold">
                  Comprobantes de pago
                </h6>
                <div class="d-flex flex-column" style="gap: 1rem">
                  <ProofItem
                    v-for="proof of request.proof_of_payment_list"
                    :key="proof.filename"
                    :item="proof"
                  />
                </div>
              </v-col>

              <!-- Facturas asociadas -->
              <v-col
                v-if="request.invoice_list?.length > 0"
                cols="12"
                class="d-flex flex-column"
                style="gap: 1rem"
              >
                <h6 class="text-subtitle-1 text-md-h6 font-weight-bold">
                  Facturas asociadas
                </h6>
                <div class="d-flex flex-column" style="gap: 1rem">
                  <ProofItem
                    v-for="invoice of request.invoice_list"
                    :key="invoice.id"
                    :item="invoice"
                    variant="invoice"
                  />
                </div>
              </v-col>
            </v-row>
          </div>
        </v-row>

        <!-- Buttons -->
        <div class="bottom-bar" ref="bottomBar" :style="bottomBarStyle">
          <div class="bottom-bar__content">
            <div
              class="interested-btn"
              :class="{ 'bottom-bar-actions--behind': fab }"
            >
              <v-btn
                class="hidden-md-and-up interested-action"
                v-if="showInterestedOptions"
                @click="iAmNotInterested"
                color="rapired"
                dark
                >No agendar</v-btn
              >

              <v-btn
                class="hidden-md-and-up interested-action"
                v-if="showInterestedOptions"
                @click="iAmInterested"
                :disabled="!selectedAvailability"
                color="secondary"
                >Agendar</v-btn
              >

              <v-btn
                class="hidden-sm-and-down interested-action"
                v-if="showInterestedOptions"
                @click="iAmNotInterested"
                color="rapired"
                dark
                large
                >No agendar</v-btn
              >

              <v-btn
                class="hidden-sm-and-down interested-action"
                v-if="showInterestedOptions"
                @click="iAmInterested"
                :disabled="!selectedAvailability"
                color="secondary"
                large
                >Agendar</v-btn
              >
            </div>

            <div class="state-services-menu">
              <v-btn
                class="hidden-md-and-up state-service-btn state-service-action"
                :class="{ 'bottom-bar-actions--behind': fab }"
                v-if="
                  (currentVisit?.visit_status === 1 || currentVisit?.visit_status === 15) &&
                  currentVisit?.visit_type.id !== 4 &&
                  request?.status_request?.id !== 13
                "
                color="secondary"
                large
                @click="showCheckInConfirmDialog()"
                >Check-in</v-btn
              >
              <v-btn
                class="hidden-md-and-up state-service-btn state-service-action"
                :class="{ 'bottom-bar-actions--behind': fab }"
                v-if="
                  request?.status_request?.id !== 13 &&
                  (currentVisit?.visit_status === 8 ||
                    currentVisit?.visit_status === 12)
                "
                color="rapired"
                dark
                large
                @click="showCheckOutConfirmDialog()"
                >check-out</v-btn
              >
              <v-btn
                class="hidden-sm-and-down state-service-action"
                :class="{ 'bottom-bar-actions--behind': fab }"
                v-if="
                  request?.status_request?.id !== 13 &&
                  currentVisit?.visit_status === 1 &&
                  currentVisit?.visit_type?.id !== 4
                "
                color="secondary"
                large
                @click="showCheckInConfirmDialog()"
                >CHECK-IN</v-btn
              >
              <v-btn
                class="hidden-sm-and-down state-service-action"
                :class="{ 'bottom-bar-actions--behind': fab }"
                v-if="
                  request?.status_request?.id != 13 &&
                  (currentVisit?.visit_status === 8 ||
                    currentVisit?.visit_status === 12)
                "
                color="rapired"
                dark
                large
                @click="showCheckOutConfirmDialog()"
                >check-out</v-btn
              >

              <v-speed-dial
                v-model="fab"
                direction="top"
                transition="slide-y-reverse-transition"
                class="speed-dial-menu"
                v-if="
                  request?.status_request?.id != 13 ||
                  (currentVisit?.visit_type?.id !== 4 &&
                    currentVisit?.visit_status !== 13 &&
                    currentVisit?.visit_status !== 14)
                "
              >
                <template v-slot:activator>
                  <v-btn v-model="fab" color="rapired" dark fab>
                    <v-icon v-if="fab">mdi-close</v-icon>
                    <v-icon v-else>menu</v-icon>
                  </v-btn>
                </template>

                <v-btn
                  v-if="
                    requestHasPendingVisit || currentVisit?.visit_status === 12
                  "
                  style="transform: translateX(-68px)"
                  color="#eeeeee"
                  class="ma-2"
                  rounded
                  large
                  @click="cancelVisitDialog = true"
                >
                  Cancelar visita
                  <v-icon right dark>clear</v-icon>
                </v-btn>

                <v-btn
                  v-if="
                    requestIsActive &&
                    requestHasPendingVisit &&
                    currentVisit?.visit_status !== 1
                  "
                  style="transform: translateX(-58px)"
                  color="#eeeeee"
                  class="ma-2"
                  rounded
                  large
                  @click="rescheduleVisitDialog = true"
                >
                  Reprogramar
                  <v-icon right dark>access_time</v-icon>
                </v-btn>

                <v-btn
                  v-if="requestHasPendingVisit"
                  style="transform: translateX(-55px)"
                  color="#eeeeee"
                  class="ma-2"
                  rounded
                  large
                  @click="noAnswerDialog = true"
                >
                  No hay nadie
                  <v-icon right dark>error_outline</v-icon>
                </v-btn>

                <v-btn
                  v-if="requestHasPendingVisit"
                  style="transform: translateX(-84px)"
                  color="#eeeeee"
                  class="ma-2"
                  rounded
                  large
                  @click="delayedArrivalDialog = true"
                >
                  Horario de llegada
                  <v-icon right dark>timer</v-icon>
                </v-btn>

                <v-btn
                  v-if="!isNewOpportunity"
                  style="transform: translateX(-60px)"
                  color="#eeeeee"
                  class="ma-2"
                  rounded
                  large
                  @click="
                    $router.push({
                      name: 'budget-list',
                      query: { request_id: request.id },
                    })
                  "
                >
                  Presupuestos
                  <v-icon right dark>attach_money</v-icon>
                </v-btn>

                <v-btn
                  style="transform: translateX(-33px)"
                  color="#eeeeee"
                  class="ma-2"
                  rounded
                  large
                  @click="galleryDialog = true"
                >
                  Galería
                  <v-icon right dark>collections</v-icon>
                </v-btn>
              </v-speed-dial>
            </div>
          </div>
        </div>
      </div>
    </v-card>

    <ConfirmCheckInDialog
      v-if="checkInDialog"
      :show="checkInDialog"
      @close-dialog="checkInDialog = false"
      @confirm-checkin="checkIn"
    />
    <ConfirmCheckOutDialog
      v-if="checkOutDialog"
      :show="checkOutDialog"
      @close-dialog="checkOutDialog = false"
      @endmetting-dialog="endMeetingDialog = true"
    />
    <AppGallery
      v-if="galleryDialog"
      :show="galleryDialog"
      :noAnswer="noAnswer"
      :gallery="request.gallery"
      :requestId="request.id"
      @reload-request="refetchRequestDetail"
      @close-dialog="galleryDialog = false"
    />
    <DelayedArrivalDialog
      v-if="delayedArrivalDialog"
      :show="delayedArrivalDialog"
      :requestId="request.id"
      :requestAddress="request.full_address"
      :visitId="currentVisit.id"
      @close-dialog="delayedArrivalDialog = false"
    />
    <ScheduleNewVisitDialog
      v-if="scheduleNewVisitDialog"
      :show="scheduleNewVisitDialog"
      :requestId="request.id"
      :technicianId="computedDetail.id"
      :requestAddress="request.full_address"
      :onPremises="currentVisit?.on_premises ?? null"
      :serviceId="request.service.id"
      @visit-scheduled="scheduleVisit"
      @close-dialog="scheduleNewVisitDialog = false"
    />
    <RescheduleVisitDialog
      v-if="rescheduleVisitDialog"
      :show="rescheduleVisitDialog"
      :requestId="request.id"
      :requestAddress="request.full_address"
      :visitId="currentVisit.id"
      :onPremises="currentVisit.on_premises"
      :serviceId="request.service.id"
      @reload-request="refetchRequestDetail"
      @close-dialog="rescheduleVisitDialog = false"
    />
    <NoAnswerDialog
      v-if="noAnswerDialog"
      :show="noAnswerDialog"
      @close-dialog="noAnswerDialog = false"
      @confirm-noanswer="confirmNoAnswer"
    />
    <end-meeting-dialog
      v-if="endMeetingDialog"
      :show="endMeetingDialog"
      :visit="currentVisit"
      :request="request"
      @close-dialog="endMeetingDialog = false"
      @reload-request="refetchRequestDetail"
    />

    <FinalizeServiceDialog
      v-if="finalizeServiceDialog"
      :show="finalizeServiceDialog"
      :requestId="request.id"
      :visitId="currentVisit.id"
      @reload-request="refetchRequestDetail"
      @close-dialog="finalizeServiceDialog = false"
    />

    <CancelVisitDialog
      v-if="cancelVisitDialog"
      :show="cancelVisitDialog"
      :visitId="currentVisit.id"
      @reload-request="refetchRequestDetail"
      @close-dialog="cancelVisitDialog = false"
    />
  </v-container>
</template>

<script>
import moment from "moment";
import { mapActions, mapGetters, mapState } from "vuex";

import BudgetsPreview from "./BudgetsPreview.vue";
import AppGallery from "./AppGallery";
import ConfirmCheckInDialog from "./ConfirmCheckInDialog";
import ConfirmCheckOutDialog from "./ConfirmCheckOutDialog";
import DelayedArrivalDialog from "./DelayedArrivalDialog";
import ScheduleNewVisitDialog from "./ScheduleNewVisitDialog";
import RescheduleVisitDialog from "./RescheduleVisitDialog";
import FinalizeServiceDialog from "./FinalizeServiceDialog";
import NoAnswerDialog from "./NoAnswerDialog";
import CancelVisitDialog from "./CancelVisitDialog";
import Loader from "./Loader";
// import ChatDetail from "./ChatDetail";
import EndMeetingDialog from "./Mobs/EndMeetingDialog.vue";
import BillServiceCard from "./BillServiceCard.vue";
import ProofItem from "./ProofItem.vue";
import SchemeIcon from "./SchemeIcon.vue";

export default {
  name: "RequestDetail",
  props: ["id"],
  components: {
    AppGallery,
    BudgetsPreview,
    ConfirmCheckInDialog,
    ConfirmCheckOutDialog,
    DelayedArrivalDialog,
    ScheduleNewVisitDialog,
    RescheduleVisitDialog,
    FinalizeServiceDialog,
    CancelVisitDialog,
    NoAnswerDialog,
    // ChatDetail,
    Loader,
    EndMeetingDialog,
    BillServiceCard,
    ProofItem,
    SchemeIcon,
  },

  data: () => ({
    detail: null,
    selectedAvailability: null,
    galleryDialog: false,
    delayedArrivalDialog: false,
    scheduleNewVisitDialog: false,
    rescheduleVisitDialog: false,
    endMeetingDialog: false,
    finalizeServiceDialog: false,
    cancelVisitDialog: false,
    fab: false,
    checkInDialog: false,
    checkOutDialog: false,
    noAnswerDialog: false,
    noAnswer: false,
    bottomBarStyle: {
      left: "0px",
      width: "100%",
    },
  }),
  computed: {
    ...mapState("request", ["currentDetail"]),
    ...mapGetters("request", ["detailLoading"]),

    computedDetail() {
      return this.currentDetail ?? this.detail;
    },

    request() {
      return this.computedDetail?.request ?? {};
    },

    displayId() {
      if (!this.request) return "";
      if (this.request.external_id) {
        return `${this.request.id} (${this.request.external_id})`;
      }
      return this.request.id;
    },

    visits() {
      return this.computedDetail?.visit ?? [];
    },

    currentVisit() {
      const foundStatus1 = this.visits.find(
        (visit) => visit.visit_status === 1
      );

      if (foundStatus1) {
        return foundStatus1;
      }

      const foundStatus8 = this.visits.find(
        (visit) => visit.visit_status === 8
      );

      if (foundStatus8) {
        return foundStatus8;
      }

      if (this.visits.length > 0) {
        return this.visits[0];
      }

      return undefined;
    },

    showInterestedOptions: function () {
      if (!this.request) return false;
      return (
        this.request.status_request?.id === 13 && this.request.respuesta == 1
      );
    },

    hasResponded: function () {
      return (
        this.request && this.request.respuesta && this.request.respuesta != 1
      );
    },

    showVisits: function () {
      if (this.request?.status_request?.id === 13) {
        switch (this.request.respuesta) {
          case 1:
            return false;
          case 2:
            return true;
          case 3:
            return false;
        }
      }
      return !!this.visits?.length;
    },

    googleMapsLink: function () {
      if (!this.request?.address_request?.maps_address) return undefined;

      return (
        "https://www.google.com/maps/search/?api=1&query=" +
        this.request.address_request.maps_address +
        "%20"
      );
    },
    googleMapsLinkClient: function () {
      if (!this.request?.address_client?.maps_address) return undefined;

      return (
        "https://www.google.com/maps/search/?api=1&query=" +
        this.request.address_client.maps_address +
        "%20"
      );
    },

    requestHasPendingVisit: function () {
      if (this.requestVisits == null) return false;
      const pendingVisit = this.requestVisits.find(
        (visit) => visit.visit_status === 1
      );
      if (pendingVisit) {
        return true;
      } else {
        return false;
      }
    },

    requestIsActive: function () {
      return (
        this.request?.status_request?.id === 10 ||
        this.request?.status_request?.id === 11 ||
        this.request?.status_request?.id === 12 ||
        this.request?.status_request?.id === 13
      );
    },

    isNewOpportunity: function () {
      return this.request?.status_request?.id === 13;
    },

    showChargesOption: function () {
      return this.requestVisits?.some(
        ({ visit_status }) => visit_status === 2 || visit_status === 8
      );
    },

    hasPermissionGranted() {
      if (!("Notification" in window)) return false;
      return Notification.permission === "granted";
    },
  },

  methods: {
    ...mapActions("request", ["getRequestById"]),

    async fetchRequestDetail(id) {
      try {
        this.detail = await this.getRequestById(id);
      } catch (error) {
        const status = error.response ? error.response.status : null;

        if (status === 404) {
          this.$router.push({
            name: "404",
            params: { resource: "información" },
          });
        } else if (status !== 401) {
          this.$router.push({ name: "network-issue" });
        }
      }
    },

    async refetchRequestDetail() {
      if (!this.request) return;

      try {
        await this.getRequestById(this.request.id);
      } catch (error) {
        console.error(error);
      }
    },

    setupBottomBarSync() {
      this.teardownBottomBarSync();
      this.syncBottomBarPosition();
      window.addEventListener("resize", this.syncBottomBarPosition);

      if (typeof ResizeObserver !== "undefined" && this.$refs.leftCol) {
        this._leftColObserver = new ResizeObserver(() => {
          this.syncBottomBarPosition();
        });
        this._leftColObserver.observe(this.$refs.leftCol);
      }

      const drawer = document.querySelector(".v-navigation-drawer");
      if (drawer && typeof MutationObserver !== "undefined") {
        this._drawerObserver = new MutationObserver(() => {
          requestAnimationFrame(() => this.syncBottomBarPosition());
        });
        this._drawerObserver.observe(drawer, {
          attributes: true,
          attributeFilter: ["class", "style"],
        });
      }
    },

    teardownBottomBarSync() {
      window.removeEventListener("resize", this.syncBottomBarPosition);
      if (this._leftColObserver) {
        this._leftColObserver.disconnect();
        this._leftColObserver = null;
      }
      if (this._drawerObserver) {
        this._drawerObserver.disconnect();
        this._drawerObserver = null;
      }
    },

    syncBottomBarPosition() {
      const col = this.$refs.leftCol;
      if (!col) return;

      const rect = col.getBoundingClientRect();
      this.bottomBarStyle = {
        left: `${Math.max(rect.left, 0)}px`,
        width: `${rect.width}px`,
      };
    },

    getPreviouslySelectedAvailability: function () {
      if (this.request) {
        const result = this.request.availability.find(
          (item) =>
            item.time_from.slice(0, 10) == this.visits[0].visit_date &&
            item.time_from.slice(11, 16) == this.visits[0].arrival_time
        );

        if (result) {
          this.selectedAvailability = result.id;
        }
      }
    },

    selectAvailability(id) {
      if (this.hasResponded) return;
      this.selectedAvailability = this.selectedAvailability === id ? null : id;
    },

    getFormattedDate(av) {
      if (av.time_from) {
        const from = moment(av.time_from);
        const to = moment(av.time_to);
        let formatted = "Desde" + " " + from.format("dddd DD MMMM");
        formatted +=
          " " +
          from.format("HH:mm") +
          " hs" +
          ", " +
          " Hasta " +
          from.format("dddd DD MMMM") +
          " " +
          to.format("HH:mm") +
          " hs";
        return formatted;
      }
    },

    formatDate(date) {
      const _date = new Date();
      const today = moment(_date).format("YYYY-MM-DD");
      if (date === today) {
        return "Hoy";
      } else {
        return moment(date, "YYYY-MM-DD").format("dddd DD MMMM, YYYY");
      }
    },

    showCheckInConfirmDialog() {
      this.checkInDialog = true;
    },

    showCheckOutConfirmDialog() {
      this.endMeetingDialog = true;
    },

    checkIn() {
      if (!this.currentVisit) return;

      const id = 10;
      const body = { id, on_premises: true };
      this.axios
        .post(`/visit/${this.currentVisit.id}/status/`, body)
        .then((_) => {
          this.refetchRequestDetail();
        });
    },

    confirmNoAnswer() {
      if (!this.currentVisit) return;

      const body = { id: 2 };

      this.axios
        .post(`visit/${this.currentVisit.id}/status/`, body)
        .then((_) => {
          this.noAnswer = true;
          this.galleryDialog = true;
        })
        .catch((error) => {
          alert("Ha ocurrido un error");
        });
    },

    setAppTitle(title) {
      this.$store.commit("set_app_title", `#${title}`);
    },

    scheduleVisit() {
      this.refetchRequestDetail();
    },

    finalizeService() {
      this.finalizeServiceDialog = true;
    },

    iAmInterested() {
      const body = {
        reply: true,
        availability: this.selectedAvailability,
      };

      const { id } = this.computedDetail ?? {};

      if (id) {
        this.axios
          .put(`request_technician/${id}/reply/`, body)
          .then((_) => {
            this.$route.params &&
              this.$route.params.notificationId &&
              this.axios.delete(
                `notification/${this.$route.params.notificationId}/`
              );
            this.$store.commit("show_alert", "Se ha marcado como Interesado");
            this.refetchRequestDetail();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    iAmNotInterested() {
      const body = {
        reply: false,
      };
      const { id } = this.computedDetail ?? {};

      if (id) {
        this.axios
          .put(`request_technician/${id}/reply/`, body)
          .then((_) => {
            this.$route.params &&
              this.$route.params.notificationId &&
              this.axios.delete(
                `notification/${this.$route.params.notificationId}/`
              );
            this.$store.commit(
              "show_alert",
              "Se ha marcado como No Interesado"
            );
            this.refetchRequestDetail();
            this.$router.push("notification-list");
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },

  watch: {
    id: {
      immediate: true,
      async handler(newValue) {
        await this.fetchRequestDetail(newValue);
        this.$store.commit(
          "set_app_title",
          `Pedido ${this.displayId ? this.displayId : newValue}`
        );
        this.$nextTick(() => this.setupBottomBarSync());
      },
    },
    computedDetail: {
      handler(newValue) {
        if (
          newValue &&
          newValue.respuesta === 2 &&
          this.isNewOpportunity &&
          this.hasResponded
        ) {
          this.getPreviouslySelectedAvailability();
        }
        this.$nextTick(() => this.setupBottomBarSync());
      },
      deep: true,
    },
  },

  beforeDestroy() {
    this.teardownBottomBarSync();
  },
};
</script>

<style scoped>
.menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  z-index: 6;
}

.availability-options {
  position: relative;
  z-index: 0;
}

.availability-options >>> .v-input__control,
.availability-options >>> .v-input--radio-group__input {
  width: 100%;
}

.availability-options >>> .v-radio,
.availability-options >>> .v-input--selection-controls__input {
  margin-right: 0;
  z-index: 0;
}

.availability-card {
  cursor: pointer;
  position: relative;
  z-index: 0;
  gap: 1rem;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  box-sizing: border-box;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.availability-card.highlighted {
  background: #e1f5fe;
  border-color: #90caf9;
}

.availability-card.regular {
  background: #f5f5f5;
  border-color: #bdbdbd;
}

.availability-card__label {
  flex: 1 1 auto;
  min-width: 0;
  padding-right: 0.25rem;
}

.availability-card__radio {
  flex: 0 0 auto;
  pointer-events: none;
}

.availability-card--disabled {
  cursor: default;
  pointer-events: none;
}
/* se quito de finzaliar servicio mobile porque se agrego cancelar servicio Cristopher
.end-btn {
  position: relative;
  left: 6rem;
} */
.icon-details {
  width: 25px;
}
.interested-btn {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 1rem;
}

.interested-action,
.state-service-action {
  min-height: 44px;
  white-space: nowrap;
}

.interested-action {
  width: 100%;
}

img {
  width: 2%;
}
.bottom-bar {
  position: fixed;
  bottom: 0;
  padding: 0 0 1.5rem;
  pointer-events: none;
  z-index: 7;
  box-sizing: border-box;
}
.bottom-bar__content {
  width: 100%;
  min-height: 72px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1.5rem;
  pointer-events: none;
  box-sizing: border-box;
  padding-right: 12px;
}
.bottom-bar__content > * {
  pointer-events: auto;
}
.state-services-menu {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1.5rem;
  flex-shrink: 0;
}
.bottom-bar-actions--behind {
  opacity: 0.3;
  pointer-events: none !important;
}
.speed-dial-menu {
  position: relative;
  z-index: 1;
}
.speed-dial-menu >>> .v-speed-dial__list {
  pointer-events: auto;
}
.v-speed-dial {
  display: flex;
  justify-content: flex-end;
}
@media (max-width: 959px) {
  img {
    width: 5%;
  }
  .bottom-bar__content {
    align-items: flex-end;
    gap: 1.5rem;
    padding-right: 12px;
  }
  .interested-btn {
    max-width: calc(100vw - 84px);
  }
  .state-services-menu {
    flex: 0 0 auto;
    gap: 1.5rem;
  }
  .state-service-action {
    max-width: calc(100vw - 84px);
  }
  .left-col {
    width: 100%;
    padding-bottom: 120px;
  }
  .overlay {
    background: #424242;
    opacity: 0.7;
  }
  .dim {
    opacity: 0.3;
  }
}
@media (min-width: 960px) {
  .dim {
    opacity: 0.3;
  }
  .left-col {
    width: 65%;
    padding-bottom: 120px;
  }
  .close-icon-container {
    display: flex;
    justify-content: flex-end;
  }
  .regular {
    background: #eeeeee;
  }
  .fix-desk {
    transform: translateX(260px);
  }
  .overlay {
    background: #424242;
    opacity: 0.7;
  }
}
.left-col {
  transition: 1s;
}
.highlighted {
  background: #e1f5fe;
}

.menu-container {
  padding: 0;
  display: flex;
  justify-content: flex-end;
}
.pb0 {
  padding-bottom: 0;
}
.pt0 {
  padding-top: 0;
}
.p0 {
  padding: 0;
}
.m0 {
  margin: 0;
}
.in-bl {
  display: inline-block;
}
.icon-cont {
  display: flex;
  justify-content: flex-end;
}
.fab-but-cont {
  display: flex;
  justify-content: flex-start;
}
.loader-container {
  height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.request-detail-card {
  min-height: 100%;
  padding: 16px 24px;
  box-sizing: border-box;
}
.urgent {
  background-color: rgba(255, 251, 203, 1) !important;
}

.req__list {
  display: flex;
  padding: 0;
  justify-content: center;
  align-content: center;
  align-items: flex-start;
  flex-direction: column;
  margin-top: 0.5rem;
  font-size: 1rem;
  color: #3a3a3a;
}
.req__list_item {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 0.9rem;
  font-weight: bold;
  margin-left: 1.2rem;
  font-weight: 400;
}

.v-application p {
  margin-bottom: 0px;
}
</style>
